import { AssetTypeSortOption } from '@rematter/frontend-lib-api-client';

import { AssetTypeRecord } from '~/modules/transportation/types';
import { createQueryHook } from '~/shared/providers/api';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const useAssetTypesQuery = createQueryHook(
  'transportation.assetTypes',
  (params: {
    ids?: string[];
    searchTerm?: string;
    facilityIds?: string[];
    accountAddressIds?: string[];
    limit?: number;
    offset?: number;
    sorting: AssetTypeSortOption[];
  }) => ({
    assetTypes: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
          facilityIds: params.facilityIds,
          accountAddressIds: params.accountAddressIds,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
        description: true,
        capacity: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { assetTypes: AssetTypeRecord[]; total?: number } => ({
      assetTypes: data?.assetTypes.entries.map((it) => ({
        id: it.id,
        name: it.name,
        description: it.description,
        capacity: it.capacity,
        timestamps: {
          createdAt: parseZonedDateTime(it.timestamps.createdAt),
          updatedAt: parseZonedDateTime(it.timestamps.updatedAt),
        },
      })),
      total: data?.assetTypes.page.total ?? undefined,
    }),
  },
);
